



// FNV-1a string hash → 32-bit unsigned int
const hashString = (str: string): number => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

// Mulberry32 PRNG: deterministic float in [0, 1) from a 32-bit seed
const seededRandom = (seed: string): number => {
  let t = (hashString(seed) + 0x6d2b79f5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

// Deterministic random number in [min, max] snapped to `step` (default 0.05)
const randomInRange = (
  seed: string,
  min: number,
  max: number,
  step: number = 0.05
): number => {
  const rand = seededRandom(seed);
  const stepCount = Math.floor((max - min) / step) + 1;
  const idx = Math.floor(rand * stepCount);
  // Snap to grid using integer math to avoid FP drift (e.g. 0.15000000000000002)
  const inv = 1 / step;
  return Math.round((min + idx * step) * inv) / inv;
};



export {
  randomInRange
};
